import DrawingMode from '../interface/drawingMode';
import consts from '../lib/consts';

const { drawingModes } = consts;
const components = consts.componentNames;

/**
 * PathMode class
 * @class
 * @ignore
 */
class PathMode extends DrawingMode {
  constructor() {
    super(drawingModes.PATH);
  }

  /**
   * start this icon mode
   * @param {Graphics} graphics - Graphics instance
   * @override
   */
  start(graphics) {
    const comp = graphics.getComponent(components.PATH);
    comp.start();
  }

  /**
   * stop this icon mode
   * @param {Graphics} graphics - Graphics instance
   * @override
   */
  end(graphics) {
    const comp = graphics.getComponent(components.PATH);
    comp.end();
  }
}

export default PathMode;
